import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseContainer',
  props: {
  mode: {
    type: String,
    required: false,
    default: null,
  },
  authPadding: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;


const modeClass = props.mode != null ? "base__container--" + props.mode : "";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["base__container", [_unref(modeClass), { 'base__container--auth': __props.authPadding }]])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})